import React from 'react'

interface Props {
  title: string
  selected: boolean
  onClick: () => void
  iconName: string
}
const Item = ({title, selected, onClick, iconName}: Props) => {
  return (
    // This div should be a button so the disabled lint rules can be re-added.
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div onClick={onClick} className={`list-item ${selected ? 'selected' : ''}`}>
      <i
        className={`fa-regular icon ${iconName}`}
        style={{fontSize: iconName === 'fa-user' ? '18px' : '17px'}}
      />
      <div className="list-title">{title}</div>
    </div>
  )
}

export default Item
